import React from "react";
import CUMonthWise from "./CUMonthWise";
import { sumArrayOfObjects } from "../../../Utilitie";
import CULobbyWise from "./CULobbyWise";
const CUCategoryMaster = ({ data, passedCD }) => {
  const lobbyWiseSum = sumArrayOfObjects(
    data,
    ["ut_lobby", "ut_year"],
    [],
    "group_by"
  ); //% data is also just added must divide with te no of month length
  const monthLength = [...new Set(data.map((o) => o.ut_month))].length;
  return (
    <div className="">
      <div className="row h-100">
        <div className="col-md-6 h-100">
          <CUMonthWise data={passedCD} />
        </div>
        <div className="col-md-6 h-100">
          <CULobbyWise data={lobbyWiseSum} monthLength={monthLength} />
        </div>
      </div>
    </div>
  );
};
export default CUCategoryMaster;
